import { getConfig } from '@sortlist-frontend/config';
import type { MouseEvent } from 'react';

import { OPEN_BRIEFING, useBriefingMessage } from '_components/Briefing/versions/NormalBriefing/BriefingDialog';
import { usePublicAppContext } from '_core/context/public-app-context';

import { BriefingTarget, getBriefingPageUrl } from './useBriefingUrl';

export const useBriefingLink = (target: BriefingTarget) => {
  const { publicEnv } = getConfig();
  const { locale } = usePublicAppContext();
  const { sendMessage } = useBriefingMessage();

  const openBriefing = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    sendMessage(OPEN_BRIEFING, target);
  };

  return {
    href: getBriefingPageUrl(publicEnv.appUrl, locale),
    rel: 'nofollow',
    onClick: openBriefing,
  };
};
